<script setup lang="ts">
    import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
    import '@splidejs/vue-splide/css';
    import type { TrainingsListingItem } from '~/types/academy/baseTraining';

    const { items } = defineProps<{
        items: TrainingsListingItem[];
    }>();

    const splideOptions = {
        fixedWidth: '306px',
        perMove: 1,
        gap: '1rem',
        pagination: false,
        focus: 0,
        omitEnd: true,
        breakpoints: {
            640: { fixedWidth: '16rem' }
        }
    };
</script>

<template>
    <Splide
        v-if="items.length"
        class="carousel-splide"
        :has-track="false"
        :options="splideOptions"
        :aria-label="$t('academy.trainings.carousel.ariaLabel')"
    >
        <div class="splide__arrows">
            <button
                class="splide__arrow splide__arrow--prev"
                :aria-label="$t('general.previous')"
                type="button"
            >
                <Icon
                    name="lucide:chevron-left"
                    size="24px"
                />
            </button>
            <button
                class="splide__arrow splide__arrow--next"
                :aria-label="$t('general.next')"
                type="button"
            >
                <Icon
                    name="lucide:chevron-right"
                    size="24px"
                />
            </button>
        </div>

        <SplideTrack>
            <SplideSlide
                v-for="item in items"
                :key="item.id"
                class="carousel-slide"
            >
                <TeaserCard :item="item" />
            </SplideSlide>
        </SplideTrack>
    </Splide>
</template>
